import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=1484888b&scoped=true"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordDialog.vue?vue&type=style&index=0&id=1484888b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1484888b",
  null
  
)

export default component.exports